import { useMutation } from '@betterment/js-runtime';

import { urlBuilder } from '../../Shared/urlBuilder';

type Params = {
  inputText: string;
  agentId: string;
  agentAliasId: string;
  sessionId: string;
};

export const useSendMessage = () =>
  useMutation<{ message: string }, Params>(urlBuilder.apiV2AgentsAdminPlayground.absolute(), { method: 'post' });
